import { type ReactNode } from 'react'
import { type CardThemeTokens, withOpacity } from '@terros/common'
import { SimpleGrid, Stack, Text } from '@mantine/core'
import { type MaterialSymbolType, useTranslation } from '@front/model'
import { MaterialSymbolIcon } from '@components'

type ActionTile = {
  icon: MaterialSymbolType
  label: string
}

export const PreviewActionTiles = ({ tokens }: { tokens: CardThemeTokens }): ReactNode => {
  const { t } = useTranslation()
  const tiles: ActionTile[] = [
    { icon: 'call', label: t('Call') },
    { icon: 'chat', label: t('Text') },
    { icon: 'person_add', label: t('Save') },
    { icon: 'ios_share', label: t('Share') },
  ]

  return (
    <SimpleGrid cols={4} spacing='xs'>
      {tiles.map(({ icon, label }) => (
        <Stack
          key={icon}
          align='center'
          bg={withOpacity(tokens.bannerTile)}
          bdrs='xl'
          c={tokens.onBanner}
          gap='xs'
          py='sm'
        >
          <MaterialSymbolIcon icon={icon} size='lg' />
          <Text fw={600} size='xs'>
            {label}
          </Text>
        </Stack>
      ))}
    </SimpleGrid>
  )
}
